<template>

    <div class="row">
        <div class="col-md-6 col-lg-4 col-lg-offset-2">
            <div class="box box-solid">
                <div class="box-header">
                    <h2 v-if="document.mimetype === 'text/xml'" class="box-title">E-factuur informatie</h2>
                    <h2 v-else class="box-title">Document informatie</h2>
                    <div class="box-tools">
                        <a
                            :href="documentRoute"
                            target="_blank"
                            class="btn btn-primary"
                            v-tooltip="document.mimetype === 'text/xml' ? 'E-factuur openen' : 'Document openen'"
                        >
                            <i class="mdi mdi-open-in-app"></i>
                        </a>
                    </div>
                </div>
                <div class="box-body">
                    <div v-if="moduleIsActive('documents') && document.is_template === false">
                        <div class="form-group">
                            <label for="subject">Onderwerp</label>
                            <input
                                type="text"
                                id="subject"
                                class="form-control"
                                name="subject"
                                v-model="document.subject"
                            />
                        </div>
                        <div class="form-group">
                            <label for="name">Bestandsnaam</label>
                            <input
                                type="text"
                                id="name"
                                class="form-control"
                                name="subject"
                                v-model="document.name"
                            />
                        </div>
                        <div class="form-group text-right">
                            <button
                                class="btn btn-primary"
                                type="button"
                                @click="onSubmit"
                                :disabled="posting"
                            >{{ Lang.get("global.save") }}</button>
                        </div>
                    </div>
                    <div v-else>
                        <div class="callout callout-info" v-if="document.is_template === true">
                            Dit is een bestand dat gekoppeld is aan een template
                        </div>
                        <div class="row" v-if="document.subject !== ''">
                            <div class="col-sm-3 text-right text-bold">Onderwerp</div>
                            <div class="col-sm-9">{{ document.subject }}</div>
                        </div>
                        <div class="row">
                            <div class="col-sm-3 text-right text-bold">Bestandsnaam</div>
                            <div class="col-sm-9">{{ document.name }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-md-6 col-lg-4">
            <div class="box box-solid" v-if="loaded && document.is_template === false">
                <div class="box-header">
                    <h2 class="box-title">Koppelingen</h2>
                    <add-connection
                        v-if="moduleIsActive('documents')"
                        :attach-uri="route('api.v1.documents.attach', {uuid:document.uuid})"
                        @connectionCompleted="connectionAdded"
                        @connectionFailed="connectionFailed"
                        :crm="document.access.crm"
                        :projects="document.access.projects"
                        :users="document.access.users"
                    ></add-connection>
                </div>
                <div class="box-body no-padding">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th>Type</th>
                                <th>Koppeling</th>
                                <th>&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="document.connections.length === 0">
                                <td colspan="3">Dit document is niet gekoppeld met andere onderdelen en wordt alleen op de 'Mijn documenten' pagina gepresenteerd</td>
                            </tr>
                            <tr
                                v-for="connection in document.connections"
                                :key="'connection-' + connection.uuid"
                                :id="'connection-' + connection.uuid"
                            >
                                <td>{{ connection.connection }}</td>
                                <td>
                                    <a
                                        v-if="typeof connection.url === 'string'"
                                        :href="connection.url"
                                    >
                                        {{ connection.name }}
                                    </a>
                                    <router-link
                                        v-else
                                        :to="connection.url"
                                    >
                                        {{ connection.name }}
                                    </router-link>
                                </td>
                                <td class="text-right">
                                    <delete-button
                                        v-if="moduleIsActive('documents')"
                                        :parent-element="'connection-' + connection.uuid"
                                        :url="route('api.v1.documents.detach', {uuid: document.uuid, connection_uuid:connection.uuid})"
                                        title="Koppeling met document"
                                        :name="'koppeling met ' + connection.name"
                                        class="btn-xs"
                                        v-tooltip="'Koppeling verwijderen'"
                                    ></delete-button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

import axios from 'axios';
import { mapGetters } from 'vuex';
import Lang from '../../Lang';
import AddConnection from "../../components/Documents/AddConnection";

export default {

    components: {
        AddConnection,
    },

    computed: {

        ...mapGetters([
            'moduleIsActive',
        ]),

        documentRoute() {
            if (!this.loaded) {
                return '';
            }

            return this.document.paths.open;
        },

        postData() {
            return {
                name:this.document.name,
                subject:this.document.subject,
            }
        },

    },

    data() {
        return {
            document:{},
            Lang:Lang,
            loaded:false,
            posting:false,
        }
    },

    metaInfo: {
        title:'Document',
    },

    methods: {
        connectionAdded() {
            this.$snotify.success('De koppeling is gemaakt');
            this.reload();
        },

        connectionFailed() {
            this.$snotify.error('Er is een fout opgetreden bij het koppelen aan dit bestand');
        },

        getDocument(uuid) {
            axios.get(this.route('api.v1.documents.show', {uuid: uuid}))
                .then(resp => {
                    this.document = resp.data.data;
                    this.loaded = true;
                });
        },

        onSubmit() {
            this.posting = true;
            axios.post(this.route('api.v1.documents.update', {uuid:this.document.uuid}), this.postData)
                .then(() => this.$snotify.success('Het document is aangepast'))
                .catch(() => this.$snotify.error('Er is een fout opgetreden bij het opslaan van dit document.'))
                .finally(() => this.posting = false);
        },

        reload() {
            this.loaded = false;
            this.getDocument();
        },
    },

    mounted(){
        this.getDocument(this.$route.params.uuid);
    },

    name:'DocumentsShow',

}

</script>
